let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5i3SC")).then(() => parcelRequire('iCQxS'));